import { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default class Path extends Component {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
    isSmall: PropTypes.bool.isRequired
  }

  static defaultProps = {
    isMobile: false,
    isSmall: false
  }

  constructor() {
    super()

    this.state = {
      isExpanded: false
    }
  }

  render() {
    const { isMobile, isSmall } = this.props

    return (
      <div
        className={classNames('slds-path', 'slds-is-expanded', {
          'slds-is-mobile': isMobile
        })}
      >
        <div
          className={classNames('slds-grid', 'slds-path__track', {
            'slds-has-overflow': isSmall || isMobile
          })}
        >
          <div className="slds-grid slds-path__scroller-container">
            <button
              className="slds-button slds-button_icon slds-button_icon-border-filled slds-path__trigger slds-flip_vertical"
              title="Collapse Sales Coaching Tab Panels"
              style={{ display: isMobile ? 'none' : '' }}
            >
              <svg className="slds-button__icon" aria-hidden="true">
                <use
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  xlinkHref="/icons/utility-sprite/svg/symbols.svg#chevrondown"
                />
              </svg>
              <span className="slds-assistive-text">
                Collapse Sales Coach Tab Panels
              </span>
            </button>
            <div className="slds-path__scroller" role="application">
              <div className="slds-path__scroller_inner">
                <ul className="slds-path__nav" role="tablist">
                  <li
                    className="slds-path__item slds-is-complete"
                    role="presentation"
                  >
                    <a
                      aria-controls="path-content-1"
                      aria-expanded="true"
                      aria-selected="false"
                      className="slds-path__link"
                      href="javascript:void(0);"
                      id="path-1"
                      role="tab"
                      tabIndex="-1"
                    >
                      <span className="slds-path__stage">
                        <svg
                          className="slds-icon slds-icon_x-small"
                          aria-hidden="true"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"
                          />
                        </svg>
                        <span className="slds-assistive-text">
                          Stage Complete
                        </span>
                      </span>
                      <span className="slds-path__title">Contacted</span>
                    </a>
                  </li>
                  <li
                    className="slds-path__item slds-is-complete"
                    role="presentation"
                  >
                    <a
                      aria-controls="path-content-2"
                      aria-expanded="true"
                      aria-selected="false"
                      className="slds-path__link"
                      href="javascript:void(0);"
                      id="path-2"
                      role="tab"
                      tabIndex="-1"
                    >
                      <span className="slds-path__stage">
                        <svg
                          className="slds-icon slds-icon_x-small"
                          aria-hidden="true"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"
                          />
                        </svg>
                        <span className="slds-assistive-text">
                          Stage Complete
                        </span>
                      </span>
                      <span className="slds-path__title">Open</span>
                    </a>
                  </li>
                  <li
                    className="slds-path__item slds-is-current slds-is-active"
                    role="presentation"
                  >
                    <a
                      aria-controls="path-content-3"
                      aria-expanded="true"
                      aria-selected="true"
                      className="slds-path__link"
                      href="javascript:void(0);"
                      id="path-3"
                      role="tab"
                      tabIndex="0"
                    >
                      <span className="slds-path__stage">
                        <svg
                          className="slds-icon slds-icon_x-small"
                          aria-hidden="true"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"
                          />
                        </svg>
                        <span className="slds-assistive-text">
                          Current Stage:
                        </span>
                      </span>
                      <span className="slds-path__title">Unqualified</span>
                    </a>
                  </li>
                  <li
                    className="slds-path__item slds-is-incomplete"
                    role="presentation"
                  >
                    <a
                      aria-controls="path-content-4"
                      aria-expanded="true"
                      aria-selected="false"
                      className="slds-path__link"
                      href="javascript:void(0);"
                      id="path-4"
                      role="tab"
                      tabIndex="-1"
                    >
                      <span className="slds-path__stage">
                        <svg
                          className="slds-icon slds-icon_x-small"
                          aria-hidden="true"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"
                          />
                        </svg>
                      </span>
                      <span className="slds-path__title">Nurturing</span>
                    </a>
                  </li>
                  <li
                    className="slds-path__item slds-is-incomplete"
                    role="presentation"
                  >
                    <a
                      aria-controls="path-content-5"
                      aria-expanded="true"
                      aria-selected="false"
                      className="slds-path__link"
                      href="javascript:void(0);"
                      id="path-5"
                      role="tab"
                      tabIndex="-1"
                    >
                      <span className="slds-path__stage">
                        <svg
                          className="slds-icon slds-icon_x-small"
                          aria-hidden="true"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"
                          />
                        </svg>
                      </span>
                      <span className="slds-path__title">Closed</span>
                    </a>
                  </li>
                </ul>
                <div
                  className="slds-path__scroll-controls"
                  style={{ display: isMobile ? 'none' : '' }}
                >
                  <button
                    className="slds-button slds-button_icon slds-button_icon-border-filled"
                    title="Scroll left"
                    tabIndex="-1"
                  >
                    <svg className="slds-button__icon" aria-hidden="true">
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="/icons/utility-sprite/svg/symbols.svg#left"
                      />
                    </svg>
                    <span className="slds-assistive-text">Scroll left</span>
                  </button>
                  <button
                    className="slds-button slds-button_icon slds-button_icon-border-filled"
                    title="Scroll right"
                    tabIndex="-1"
                  >
                    <svg className="slds-button__icon" aria-hidden="true">
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="/icons/utility-sprite/svg/symbols.svg#right"
                      />
                    </svg>
                    <span className="slds-assistive-text">Scroll right</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="slds-grid slds-path__action">
            <span className="slds-path__stage-name">Stage: Unqualified</span>
            <button className="slds-button slds-button_brand slds-path__mark-complete">
              <svg
                className="slds-button__icon slds-button__icon_left"
                aria-hidden="true"
              >
                <use
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"
                />
              </svg>Mark Status as Complete
            </button>
          </div>
        </div>

        <div
          aria-labelledby="path-3"
          className="slds-path__content slds-show"
          id="path-content-3"
          role="tabpanel"
        >
          <div className="slds-path__coach slds-grid">
            <div className="slds-path__keys slds-form slds-form_stacked">
              <div className="slds-grid slds-grid_align-spread slds-path__coach-title">
                <h2>Key Fields This Stage</h2>
                <button className="slds-button slds-button_reset slds-text-body_small">
                  Edit
                </button>
              </div>
              <ul>
                <li className="slds-form-element slds-hint-parent slds-border_bottom slds-form-element_edit">
                  <span className="slds-form-element__label">
                    Expected Budget
                  </span>
                  <div className="slds-form-element__control">
                    <span className="slds-form-element__static">$10,000</span>
                    <button
                      className="slds-button slds-button_icon slds-float_right slds-button_icon slds-button_icon-small"
                      title="Edit this Field"
                    >
                      <svg
                        className="slds-button__icon slds-button__icon_hint"
                        aria-hidden="true"
                      >
                        <use
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          xlinkHref="/icons/utility-sprite/svg/symbols.svg#edit"
                        />
                      </svg>
                      <span className="slds-assistive-text">
                        Edit this Field
                      </span>
                    </button>
                  </div>
                </li>
                <li className="slds-form-element slds-hint-parent slds-border_bottom slds-form-element_edit">
                  <span className="slds-form-element__label">Lead Source</span>
                  <div className="slds-form-element__control">
                    <span className="slds-form-element__static">
                      Marketing and Web Referral
                    </span>
                    <button
                      className="slds-button slds-button_icon slds-float_right slds-button_icon slds-button_icon-small"
                      title="Edit this Field"
                    >
                      <svg
                        className="slds-button__icon slds-button__icon_hint"
                        aria-hidden="true"
                      >
                        <use
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          xlinkHref="/icons/utility-sprite/svg/symbols.svg#edit"
                        />
                      </svg>
                      <span className="slds-assistive-text">
                        Edit this Field
                      </span>
                    </button>
                  </div>
                </li>
                <li className="slds-form-element slds-hint-parent slds-border_bottom slds-form-element_edit">
                  <span className="slds-form-element__label">
                    Support Engineer
                  </span>
                  <div className="slds-form-element__control">
                    <span className="slds-form-element__static">
                      Jack Arthur
                    </span>
                    <button
                      className="slds-button slds-button_icon slds-float_right slds-button_icon slds-button_icon-small"
                      title="Edit this Field"
                    >
                      <svg
                        className="slds-button__icon slds-button__icon_hint"
                        aria-hidden="true"
                      >
                        <use
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          xlinkHref="/icons/utility-sprite/svg/symbols.svg#edit"
                        />
                      </svg>
                      <span className="slds-assistive-text">
                        Edit this Field
                      </span>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <div className="slds-path__guidance">
              <h2 className="slds-path__coach-title">Guidance for Success</h2>
              <div className="slds-text-longform slds-path__guidance-content">
                <p>
                  Regularly cross-sell related products using{' '}
                  <a href="javascript:void(0);">
                    cross-sell tactics and principles
                  </a>.
                </p>
                <p>
                  Prepare demo deck using the{' '}
                  <a href="javascript:void(0);">latest template</a> and review
                  with Marketing and Sales teams. Review demo copy with Legal
                  and Doc team.
                </p>
                <p>
                  Look up{' '}
                  <a href="javascript:void(0);">needs analysis principles</a>{' '}
                  and review selling plan with Sales Engineer.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="slds-scoped-notification slds-media slds-media_center slds-theme_info" role="status">
          <div class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-warning" title="warning">
              <svg class="slds-icon slds-icon_small" aria-hidden="true">
                <use xlinkHref="/static/slds-source/assets/icons/utility-sprite/svg/symbols.svg#info"></use>
              </svg>
              <span class="slds-assistive-text">warning</span>
            </span>
          </div>
          <div class="slds-media__body">
            <p>This is an Informational scoped notification message.
              <a href="#">Link</a>
            </p>
          </div>
        </div>

        <style jsx>{`
          .slds-path.slds-is-mobile .slds-path__track {
            flex-direction: column;
            top: 0;
            margin: 1rem 0;
          }

          .slds-path.slds-is-mobile .slds-path__scroller-container {
            width: 100%;
            padding-right: 0;
          }

          .slds-path.slds-is-mobile .slds-path__action {
            flex-direction: column;
            align-items: center;
          }

          .slds-path.slds-is-mobile .slds-path__stage-name {
            display: block;
            margin: 1rem 0;
          }

          .slds-path.slds-is-mobile .slds-path__item {
            min-width: 100px;
          }

          .slds-path.slds-is-mobile .slds-path__coach {
            flex-wrap: wrap;
          }

          .slds-path.slds-is-mobile .slds-path__keys,
          .slds-path.slds-is-mobile .slds-path__guidance {
            width: 100%;
            margin-right: 0;
          }
        `}</style>
      </div>
    )
  }
}
